import { Navigate, Outlet } from 'react-router-dom'

const GuardedRoute = () => {
    let auth = JSON.parse(localStorage.getItem("user"));
    return (
      auth ? <Outlet/> : <Navigate to='/'/>
    )
}

export default GuardedRoute;